<template>
  <div v-if="data.contractName" class="box">
    <div class="contract-index-box">
      <div class="contract-title">{{ data.contractName }}</div>
      <div class="contract-desc" v-html=" data.content"></div>
      <div
        v-for="(item, index) in data.contractData"
        :key="index"
      >
        <component
          :is="item.componentName"
          :info="item.data"
          :isStartGenerate="isStartGenerate"
          :signatureImg="signatureImg"
          @getSignature="getSignature"
          @touchstart.native="touchstart"
          ref="data"
        />
      </div>
      <!-- 签名 start -->
      <ContractSignature
        v-if="isDisplaySignture"
        :is-start-generate="isStartGenerate"
        :signatureImg="signatureImg"
        @getSignature="getSignature"
        @touchstart.native="touchstart"
      />
      <!-- 签名 end -->

      <div v-if="!isStartGenerate" class="submit-btn-box">
        <div class="submit-btn" @click="submit">
          <i v-if="loading" class="el-icon-loading"></i>
          提交
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// import ContractFill from './components/contractFill.vue'
// import ContractPhone from './components/contractPhone.vue'
// import ContractDate from './components/contractDate.vue'
// import ContractEditDesc from './components/contractEditDesc.vue'
// import ContractMobile from './components/contractMobile.vue'
import {
  ContractFill,
  ContractPhone,
  ContractDate,
  ContractEditDesc,
  ContractMobile,
  ContractRadio,
  ContractCheck,
  ContractInput,
  ContractTextarea,
} from "./components";
import Signature from "@/components/signature";
import {
  getContractInfoApi,
  contractFileUploadApi,
  submitContractApi,
} from "@/api/contract";
import { dataURLtoFile } from "@/utils/utils";
import html2canvas from "html2canvas";
import { getTerminalInfo } from "@/utils/platformInfo";
import { Message } from "element-ui";
import { Toast } from "vant";
export default {
  name: "ContractIndex",

  components: {
    [ContractFill.name]: ContractFill,
    [ContractDate.name]: ContractDate,
    [ContractPhone.name]: ContractPhone,
    [ContractEditDesc.name]: ContractEditDesc,
    [ContractMobile.name]: ContractMobile,
    [ContractRadio.name]: ContractRadio,
    [ContractCheck.name]: ContractCheck,
    [ContractInput.name]: ContractInput,
    [ContractTextarea.name]: ContractTextarea,
    [Signature.name]: Signature,
  },

  data() {
    return {
      isStartGenerate: false,
      loading: false,
      data: {},
      form: {},
      allData: {},
      signatureImg: "",
      adminData: {},
    };
  },

  created() {
    this.addMessageEvent();
    setTimeout(() => {
      this.getContractInfo();
    });
  },
  computed:{
    isDisplaySignture(){
      let result = new Date(this.allData.createTime).getTime() < new Date("2022/05/20 09:00:00").getTime()
      console.log(new Date("2022/05/20 09:00:00").getTime())
      return result
    }
  },
  methods: {
    getContractInfo() {
      const { jobNumber, contractId } = this.$route.query;
      return getContractInfoApi({
        contractId,
        jobNumber,
      }).then((res) => {
        const keyMap = {
          '微信号': "partyBWx",
          '微信昵称': 'partyBWxName',
          '身份证号码': "partyBCardNumber",
          '乙方': "partyBName",
          '甲方': "partyAName",
          '联系方式': "partyBPhone",
        };
        this.allData = res.data;
        let { contractInfo } = res.data;
        if (contractInfo) {
          contractInfo = JSON.parse(contractInfo);
          document.title = contractInfo.contractName;
          contractInfo.contractData
            .filter((item) => item.sgin === "填写")
            .map((item) => {
              const dataKey = keyMap[item.data.title];
              item.data.content = this.adminData[dataKey];
            });
          contractInfo.contractData
            .filter((item) => item.sgin === "乙方电话")
            .map((item) => {
              item.data.content = this.adminData.partyBPhone;
            });
          if (this.adminData.id) {
            this.getAnswer(contractInfo.contractData, this.adminData);
          }
          this.data = contractInfo;
        }
      });
    },
    getAnswer(contractData, data) {
      let questionnaireData = contractData.filter((item) => {
        if (
          item.sgin === "单选题" ||
          item.sgin === "多选题" ||
          item.sgin === "填空题" ||
          item.sgin === "简答题" ||
          (item.sgin === "时间"&&item.data.dateType)
        ) {
          return item;
        }
      });
      let { questionContents } = data;
      if(questionContents) {
        questionnaireData.map((item) => {
          questionContents.forEach((element) => {
            if (item.data.title === element.content)
              item.data.content = element.answer;
          });
        });
      }
    },
    getSignature(res) {
      this.form.partyBSignature = res;
    },
    async submit() {
      const dataList = this.$refs.data;
      const form = {
        questionParams: []
      };
      for (let i = 0; i < dataList.length; i++) {
        if (!dataList[i].getSubmitData) {
          continue;
        }
        const result = dataList[i].getSubmitData();
        console.log(result);
        if (!result) {
          return;
        }
        if (result.questionnaire) {
          if(result.options){
            form.questionParams.push(result);
          }
        } else {
          Object.assign(form, result);
        }
      }
      if (!this.form.partyBSignature&&this.isDisplaySignture) {
        this.toast('请确认签名', 'error')
        return
      }
      this.loading = true;
      let _Toast = Toast.loading({
        message: "请稍等...",
        mask: true,
        forbidClick: true,
        duration: 0,
      });
      if (form.partyBSignature||this.form.partyBSignature) {
        // 上传签名
        const formData = new FormData();
        formData.append(
          "file",
          dataURLtoFile(
            this.isDisplaySignture
              ? this.form.partyBSignature
              : form.partyBSignature,
            "-签名-" + this.form.partyBName + ".png"
          )
        );
        const signatureData = await contractFileUploadApi(formData);
        form.partyBSignature = signatureData.data;
      }
      const { jobNumber, contractId } = this.$route.query;
      let submit = await submitContractApi({
        ...form,
        contractId: Number(contractId),
        jobNumber: Number(jobNumber),
        contractInviteId: this.allData.contractInviteId,
      });
      _Toast.clear();
      this.loading = false;
      if (submit.code !== "SUCCESS") {
        this.toast(submit.message, "error");
        return;
      }
      this.$router.push("/success");
    },
    toast(msg, type = "success") {
      const isMobile = getTerminalInfo() === "mobile";
      if (isMobile) {
        Toast({
          message: msg,
          position: "bottom",
        });
      } else {
        Message[type](msg);
      }
    },
    touchstart() {
      console.log(11);
      Array.from(document.querySelectorAll(".contract-fill-item input")).map(
        (item) => {
          item.blur();
        }
      );
    },
    addMessageEvent() {
      window.addEventListener("message", (e) => {
        const values = e.data;
        const { type } = values;
        if (type === "init") {
          this.adminInit(values);
        } else if (type === "generate") {
          this.generateCanvas();
        }
      });
    },
    // 在后台引用
    async adminInit(values) {
      this.isStartGenerate = true;
      // 设置签名图片
      this.signatureImg = values.data.partyBSignature
        ? values.data.partyBSignature + "?v=" + Date.now()
        : "";
      this.adminData = values.data;
    },
    async generateCanvas() {

      const el = document.querySelector(".contract-index-box");
      const canvasData = await html2canvas(el, {
        width: el.clientWidth,
        allowTaint: true,
        useCORS: true,
        scale: window.devicePixelRatio,
      });
      // 上传 anvas 生成的图片
      const canvasFormData = new FormData();
      canvasFormData.append(
        "file",
        dataURLtoFile(
          canvasData.toDataURL(),
          "-合同-" + this.form.partyBName + ".png"
        )
      );
      const canvasUploadData = await contractFileUploadApi(canvasFormData);
      window.parent.postMessage(
        {
          type: "generateFinish",
          data: {
            url: canvasUploadData.data,
          },
        },
        "*"
      );
    },
  },
};
</script>
<style lang="stylus" scoped>
.box {
  height: 100%;
  width: 100%;
  background: #fff;
}

.contract-index-box {
  // background: #fff
  padding: 0 20px 40px;

  .contract-title {
    padding-top: 28px;
    font-size: 24px;
    font-weight: bold;
  }
  .contract-desc {
    margin-top: 0.48309rem;
    color: #666;
    font-size: 0.33816rem;
    line-height: 0.48309rem;
    text-align: justify;
    word-break: break-all;
  }
}

.submit-btn-box {
  text-align: center;
  margin-top: 20px;

  .submit-btn {
    position: relative;
    background: #409EFF;
    color: #fff;
    font-size: 14px;
    display: inline-block;
    cursor: pointer;
    padding: 6px 0;
    margin-top: 10px;
    width: 60%;

    i {
      position: relative;
    }

    &.disable {
      cursor: not-allowed;
      opacity: 0.5;
    }
  }
}

.pc .submit-btn-box .submit-btn {
  width: 200px;
}
</style>
